import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type UserOrganisationItem = ResultOf<
  typeof userOrganisationsQuery
>["userOrganisations"]["data"][number];

export const userOrganisationsQuery = graphql(`
  query UserOrganisations($user_id: ID!, $first: Int!, $page: Int) {
    userOrganisations(user_id: $user_id, first: $first, page: $page) {
      data {
        id
        organisation {
          id
          name
          is_verified
          created_at
        }
        created_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
